import * as React from 'react';

import { GeoInputAddonSection } from './internal/components/GeoInputAddonSection';
import { DistrictsButton } from './internal/containers/DistrictsButton';
import { HighwaysButton } from './internal/containers/HighwaysButton';
import { RegionButton } from './internal/containers/RegionButton';
import { RegionalDistrictsButton } from './internal/containers/RegionalDistrictsButton';
import { UndergroundButton } from './internal/containers/UndergroundButton';

export const GeoSwitcherButtonsContainer: React.FC = () => (
  <GeoInputAddonSection>
    <RegionButton />
    <RegionalDistrictsButton />
    <DistrictsButton />
    <HighwaysButton />
    <UndergroundButton />
  </GeoInputAddonSection>
);
